import { createRouter, createWebHistory, RouteRecordRaw, RouterView } from 'vue-router';
import { setAuthToken } from '@beautybox/core/utils/auth';
import { useApi } from '@beautybox/core/plugins';
import landingRoutes from '@/router/landings';
import roleAccessMiddleware from '@/router/middlewares/roleAccessMiddleware';
const NotFound = () => import('@beautybox/ui-kit/components/pages/Errors/NotFound.vue');
const Subscriptions = () => import('@/pages/index.vue');
const ManagementTariff = () => import('@/pages/management/tariff.vue');
const ManagementModule = () => import('@/pages/management/module.vue');
const ManagementModuleSelect = () => import('@/pages/management/modules/select.vue');
const SubscriptionSelect = () => import('@/pages/subscriptions/select.vue');
const SubscriptionAbout = () => import('@/pages/subscriptions/aboutSubscription.vue');
const SubscriptionBecomeStudio = () => import('@/pages/subscriptions/becomeStudio.vue');

const errorsRoutes = {
    path: '/:pathMatch(.*)*',
    name: '404',
    meta: {
        layout: 'empty',
    },
    component: NotFound,
};

export const routes: readonly RouteRecordRaw[] = [
    {
        path: '/redirect',
        name: 'redirect',
        component: RouterView,
        beforeEnter(to, from, next) {
            const { from: fromParam, token } = { ...to.query } as Record<string, string>;
            setAuthToken(token);
            const { provider } = useApi();
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            provider.updateToken(token);
            // window.location.href = fromParam;
            const baseUrl = import.meta.env.BASE_URL;
            const domain = `${location.protocol}//${location.host}${baseUrl}`;
            console.log('domain', domain);
            const redirectTo = fromParam.replace(domain, '');
            console.log('redirectTo', redirectTo);
            next(redirectTo);
        },
    },
    {
        path: '/',
        name: 'subscriptions',
        meta: {
            layout: 'main',
            title: 'Управление подпиской',
            hideHeader: true,
        },
        component: Subscriptions,
    },
    {
        path: '/tariff',
        name: 'managementTariff',
        meta: {
            layout: 'main',
            title: 'Управление подпиской',
            back: 'subscriptions',
        },
        component: ManagementTariff,
        beforeEnter: [roleAccessMiddleware],
    },
    {
        path: '/module/:moduleIDOrAlias',
        name: 'managementModule',
        meta: {
            layout: 'main',
            title: 'Управление подпиской',
            back: 'subscriptions',
        },
        component: ManagementModule,
        beforeEnter: [roleAccessMiddleware],
    },
    {
        path: '/module-group/:moduleGroupIDOrAlias/select',
        name: 'managementModuleSelect',
        meta: {
            layout: 'main',
            hideHeader: true,
        },
        component: ManagementModuleSelect,
        beforeEnter: [roleAccessMiddleware],
    },
    {
        path: '/tariff/select',
        name: 'subscriptionSelect',
        component: SubscriptionSelect,
        meta: {
            layout: 'main',
            title: 'Выберите подписку',
            back: 'managementTariff',
            hideTitle: true,
            pageClass: 'subscription-select',
        },
        beforeEnter: [roleAccessMiddleware],
    },
    {
        path: '/about',
        name: 'aboutSubscription',
        component: SubscriptionAbout,
        meta: {
            layout: 'main',
            title: 'О подписке',
            back: 'subscriptionSelect',
            hideTitle: true,
        },
    },
    {
        path: '/become-studio',
        name: 'becomeStudio',
        component: SubscriptionBecomeStudio,
        meta: {
            layout: 'main',
            title: 'Приглашение в команду',
            back: 'managementTariff',
            hideTitle: true,
        },
        beforeEnter: [roleAccessMiddleware],
    },
    ...landingRoutes,
    errorsRoutes,
];

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),

    routes,
});

export default router;
